@if (name) {
  <div class="control-label"
    >
    {{name | translate}}:
  </div>
}
<div [ngClass]="{'search-filter-checkbox-list' : isCheckboxList}"
  class="align-center">
  <ng-content></ng-content>
</div>